import { render, staticRenderFns } from "./UserAccount.vue?vue&type=template&id=039253dc&"
import script from "./UserAccount.vue?vue&type=script&lang=js&"
export * from "./UserAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports